// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import Cookies from 'js-cookie'
import Element from 'element-ui'
import i18n from './lang/index' // Internationalization
import bView from './commons/index';
import _ from 'lodash'
import './assets/css/font.css'
import '../theme/index.css'
import 'babel-polyfill'
import _g from './assets/js/global'

require('./api/api.js')
require('./util/index.js')

import {getRules, elementuiSelect_Edge} from '@/assets/js/uitl.js'
Vue.prototype.$getRules = getRules;
Vue.prototype.$elui_Select_Edge = elementuiSelect_Edge;

Vue.config.productionTip = false
Vue.prototype._ = _
Vue.use(bView)
Vue.use(Element, {
  size: Cookies.get('size') || 'small', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// 载入全局函数
window._g = _g

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js